module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/node_modules/babel-runtime/regenerator/index.js
// module id = 55
// module chunks = 10